import { create } from 'zustand';

export type AgentStatus = 'idle' | 'thinking' | 'executing_tool' | 'awaiting_approval' | 'awaiting_input' | 'error';
export type ConnectionStatus = 'disconnected' | 'connecting' | 'connected' | 'reconnecting';

interface AgentState {
    // Connection State
    connectionStatus: ConnectionStatus;
    lastHeartbeat: number | null;

    // Agent Activity State
    status: AgentStatus;
    currentActivityDescription: string | null; // e.g., "Searching for files...", "Running tests..."
    
    // Active Context
    activeSessionId: string | null;
    activeTaskId: string | null;

    // Actions
    setConnectionStatus: (status: ConnectionStatus) => void;
    setAgentStatus: (status: AgentStatus, description?: string | null) => void;
    updateHeartbeat: () => void;
    setActiveContext: (sessionId: string | null, taskId: string | null) => void;
}

export const useAgentStore = create<AgentState>((set) => ({
    connectionStatus: 'disconnected',
    lastHeartbeat: null,
    status: 'idle',
    currentActivityDescription: null,
    activeSessionId: null,
    activeTaskId: null,

    setConnectionStatus: (status) => set({ connectionStatus: status }),
    
    setAgentStatus: (status, description = null) => set((state) => ({ 
        status,
        currentActivityDescription: description !== null ? description : state.currentActivityDescription
    })),

    updateHeartbeat: () => set({ lastHeartbeat: Date.now() }),

    setActiveContext: (sessionId, taskId) => set({ activeSessionId: sessionId, activeTaskId: taskId }),
}));



